export default "__VITE_ASSET__c1b4e5c7__"